<template>
  <mu-container class="container animated slideInDown">
    <mu-paper class="demo-list-wrap">
      <mu-list v-if="typeof data !== 'string'" textline="two-line">
        <div v-for="item in data" :key="item.id">
          <!-- :to="{
              path: '/certificateTable',
              query: { id: item.id },
            }" -->
          <mu-list-item
            :ripple="false"
            avatar
            button
            style="height: 90px; padding: 10px 0;"
            @click="previewImg(item)"
          >
            <mu-list-item-content>
              <mu-list-item-title style="font-size: 16px;">
                {{ item.subject_name }}
              </mu-list-item-title>
              <mu-list-item-sub-title>
                <div>
                  证书编号:
                  <span>
                    {{ item.cert_no }}
                  </span>
                </div>
                <div>
                  证书有效期:
                  <span>
                    {{ item.expiration }}
                  </span>
                </div>
              </mu-list-item-sub-title>
            </mu-list-item-content>
            <mu-list-item-action>
              <mu-list-item-after-text>
                {{ item.cert_date }}
              </mu-list-item-after-text>
            </mu-list-item-action>
          </mu-list-item>
          <mu-divider></mu-divider>
        </div>
      </mu-list>
      <mu-flex
        v-if="typeof data !== 'string'"
        justify-content="center"
        class="pagination"
      >
        <mu-pagination
          raised
          circle
          :page-size="page_size"
          :total="total"
          :current.sync="current"
          @change="pageChange"
        ></mu-pagination>
      </mu-flex>
      <div v-if="showError" class="bg-info">
        <br />
        <br />
        <br />
        <mu-icon size="96" value="info" color="info"></mu-icon>
        <p class="text-center">暂无证书记录</p>
      </div>
    </mu-paper>
  </mu-container>
</template>

<script>
import { CertList } from '@/api/index'
import { ImagePreview } from "vant";

export default {
  components: {},
  props: {},
  data() {
    return {
      data: '',
      showError: false,
      current: 1,
      total: 1,
      page_size: 10,
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.resetData()
  },
  activited() {},
  update() {},
  beforeRouteUpdate() {},
  methods: {
    async resetData() {
      const res = await CertList({
        page_num: this.current,
      })
      this.data = res.data
      this.current = res.current_page
      this.total = res.total
      this.page_size = res.per_page
      if (Array.isArray(this.data) && this.data.length <= 0) {
        this.showError = true
      }
    },
    pageChange(e) {
      this.current = e
      this.resetData()
    },
    previewImg(data) {
      // console.log(data.cert_pic_url)
      ImagePreview([data.cert_pic_url]);
    }
  },
  filter: {},
}
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  position: relative;
  padding: {
    left: 0;
    right: 0;
  }
  background: #fff;
  p {
    margin: 8px 0;
  }
}
.mu-list {
  padding: 0;
}
.pagination {
  position: fixed;
  bottom: 70px;
  display: flex;
  justify-content: center;
  width: 100vw;
}
</style>
<style lang="scss"></style>
